module.exports = __webpack_public_path__ + "static/affiliate/affiliate-square_ski-bro2--swiss-7a07640c97a3338d47e522d7399de4b9.webp";